module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-209.5af1f8df.svg";